module.exports = __webpack_public_path__ + "b484187f7e746eaffa4f5d24f54efc15.svg";